<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Листы согласования</h1>
        </div>
      </div>

      <AppTabsRouter
         :tabs="tabsFilter"
         :propActiveTabIndex="activeTabIndex"
         style="margin-top: 32px"
         :loading="tabLoading"
      />
    </section>

    <section class="section page__content">

      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item user-list__search page__search" style="margin-right:16px;">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
          <AppButtonFilter
            :active="filterIsActive"
            @click.native="toggleFilter"
          />
        </div>
        <div class="table__buttons">
            <transition name="fade">
                <AppButtonSmRemove
                  v-if="isActiveDelete"
                  title="Удалить"
                  @click.stop.native="showRemoveConfirmationGroup"
                  style="margin-right: 20px"
                />
            </transition>
            <AppButtonSmAdd
              title="Создать"
              @click.stop.native="goToUpdate('create')"
            />
        </div>
      </div>

      <transition name="fade">
        <Form
          v-if="filterIsActive"
          v-model="filterData"
          ref="filterForm"
          class="filter"
        >
          <div class="filter__list">
            <AppInputDate
              name="createDate"
              title="Создано"
              type="range"
            />
            <AppInputDate
              name="updateDate"
              title="Изменено"
              type="range"
            />
            <VInput
              name="approveName"
              label="Название"
            />
            <AppInputDate
              name="endDate"
              title="Конечная дата"
              type="range"
            />
            <AppSelect
              title="Статус"
              :options="statusApproveList"
              newItemFromSearch
              placeholder="Не выбрано"
              name="status"
            />
            <VInput
              name="createBy"
              label="Создал"
            />
            <AppCheckbox
              title="Согласование по порядку"
              :checked="in_order"
              @toggle-check="in_order = !in_order"
            />

          </div>
          <div class="filter__buttons">
            <AppButton
              type="main"
              title="Показать"
              @click.stop.native="setFilter"
            />
            <AppButton
              type="alt"
              title="Сбросить"
              @click.stop.native="clearFilter"
            />
          </div>
        </Form>
      </transition>

      <router-view :key="$route.fullPath"></router-view>
    </section>

    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       text="Вы действительно хотите удалить эти заказы?"
                       @confirm="removeConfirmation.group ? deleteApproveChecked() : removeApprove()"
                       @reject="closeRemoveConfirmation"
      />
    </transition>
  </main>
</template>

<script>
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppButtonFilter from '@/components/page/button/AppButtonFilter'
import Form from '@/components/page/Form/Form'
import AppInputDate from '@/components/page/input/AppInputDate'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import AppSelect from '@/components/page/input/AppSelect'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppButton from '@/components/page/button/AppButton'
import AppTabsRouter from '@/components/page/tabs/AppTabsRouter'

export default {
  name: 'ApproveList',
  components: {
    AppConfirmation,
    AppButtonSmRemove,
    AppButtonSmAdd,
    SearchForm,
    AppTabsRouter,
    AppButtonFilter,
    Form,
    AppInputDate,
    VInput,
    AppSelect,
    AppCheckbox,
    AppButton
  },
  data: () => ({
    removeConfirmation: {
      active: false,
      id: null
    },
    // фильтр
    filterIsActive: false,
    filterData: {},
    in_order: false,
    tabs: [
      { name: 'Созданные', routeName: 'ApproveList_new', count: 0, id: 1 },
      { name: 'На согласовании', routeName: 'ApproveList_reconciliation', count: 0, id: 2 },
      { name: 'На контроль', routeName: 'ApproveList_control', count: 0, id: 3 },
      { name: 'Закрытые', routeName: 'ApproveList_closed', count: 0, id: 4 }
    ]
  }),
  computed: {
    treaties () {
      return this.$store.getters['approve/details/[approve] getItemUpdateTreaties']
    },
    tabsFilter () {
      return this.setTabs()
    },
    activeTabIndex () {
      return this.$store.getters['[approve] getActiveTabIndex']
    },
    tableHeaders () {
      return this.$store.getters['[approve] getApproveListTableHeaders']
    },
    searchValue () {
      return this.$store.getters['[approve] getApproveListSearchValue']
    },
    filter () {
      return this.$store.getters['[approve] getApproveListFilter']
    },
    statusApproveList () {
      return this.$store.getters['[approve] getApproveStatusList']
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isActiveDelete () {
      return this.$store.getters['[approve] getApproveListIsActiveDelete']
    },
    isLoading () {
      return this.$store.getters['[approve] getApproveListIsLoading']
    },
    tabLoading () {
      return this.$store.getters['[approve] getTabLoading']
    }
  },
  methods: {
    setTabs () {
      this.$store.getters['[approve] getApproveListTabsFilter'].map((item, index) => {
        this.tabs.map((tab, i) => {
          if (index === i) tab.count = item.count
        })
      })
      return this.tabs
    },
    getDateStatus (date) {
      if ((new Date() - new Date(date)) > 0) {
        return 'ПРОСРОЧЕН'
      } else if (Math.round((new Date() - new Date(date)) / (1000 * 60 * 60 * 24)) > -3) {
        return 'Срок истекает'
      } else return ''
    },
    goToUpdate (id) {
      this.$router.push({ name: 'ApproveUpdate', params: { id } })
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
      this.removeConfirmation.group = false
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeApprove () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('[approve] removeApproveListItem', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    deleteApproveChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('[approve] deleteApproveListCheckedItems')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('[approve] setApproveListSearchValue', value)
    },

    // filter
    toggleFilter () {
      this.filterIsActive = !this.filterIsActive
      this.$store.commit('[approve] SET_APPROVE_LIST_FILTER_ACTIVE', this.filterIsActive)
    },
    setFilter () {
      this.filterData.in_order = this.in_order
      this.$store.commit('[approve] SET_APPROVE_LIST_FILTER', this.filterData)
      this.$store.dispatch('[approve] getApproveListPage', 1)
      this.$store.dispatch('[approve] getApproveList')
    },
    clearFilter () {
      this.$refs.filterForm.clear()
      this.in_order = false
      this.$store.commit('[approve] SET_APPROVE_LIST_FILTER', this.filterData)
      this.$store.dispatch('[approve] getApproveListPage', 1)
      this.$store.dispatch('[approve] getApproveList')
    },

    // pagination
    togglePageList () {
      this.$store.dispatch('togglePvhOrderListPageList')
    },
    previousPage () {
      this.$store.dispatch('getPvhOrderListPrevPage')
    },
    nextPage () {
      this.$store.dispatch('getPvhOrderListNextPage')
    },
    getPage (pageNum) {
      this.$store.dispatch('getPvhOrderListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('approve/details/[approve] getTreaties')
    this.filterData = this.filter
    this.in_order = this.filterData.in_order
    this.filterIsActive = this.$store.getters['[approve] getFilterIsActive']
  },
  destroyed () {
    this.$store.commit('[approve] RESET_APPROVE_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}

.table__buttons {
  margin-bottom: 0;
}

</style>
